// extracted by mini-css-extract-plugin
export default {"card":"a3-z","carouselContainer":"b3-z","carouselContent":"c3-z"};